import { axiosJSONInstance } from '@/config';
import { NotificationCounts, NotificationItem, ResponseListType, ResponseType } from '@/types';

// Fetch List Notification
export const fetchNotificationsList = async (
  page: number,
  notificationType?: string,
): Promise<ResponseListType<NotificationItem>> => {
  const response = await axiosJSONInstance.get(`/merchants/notifications`, {
    params: {
      filter_type: notificationType,
      perpage: 30,
      page,
    },
  });
  return response.data;
};
// Get Notification count
export const fetchNotificationsCount = async (): Promise<ResponseType<NotificationCounts>> => {
  const response = await axiosJSONInstance.get(`/merchants/notifications/unseen-count`);
  return response.data;
};

export const seenNotification = async (notificationIds: string[]): Promise<void> => {
  const response = await axiosJSONInstance.post('/merchants/notifications/seen', {
    ids: notificationIds,
  });

  return response.data;
};

// Notification Preferences
export interface NotificationPreferences {
  orders: boolean;
  finance: boolean;
  support: boolean;
  announcements: boolean;
}

export const fetchNotificationPreferences = async (): Promise<ResponseType<NotificationPreferences>> => {
  const response = await axiosJSONInstance.get('/merchants/notification-preferences');
  return response.data;
};

export const updateNotificationPreferences = async (
  data: Partial<NotificationPreferences>,
): Promise<ResponseType<NotificationPreferences>> => {
  const response = await axiosJSONInstance.patch('/merchants/notification-preferences', data);
  return response.data;
};
